export const locationCities = [
  { slug: 'new-york-city', name: 'New York City', state: 'NY' },
  { slug: 'los-angeles', name: 'Los Angeles', state: 'CA' },
  { slug: 'chicago', name: 'Chicago', state: 'IL' },
  { slug: 'houston', name: 'Houston', state: 'TX' },
  { slug: 'miami', name: 'Miami', state: 'FL' },
  { slug: 'san-francisco', name: 'San Francisco', state: 'CA' },
  { slug: 'austin', name: 'Austin', state: 'TX' },
  { slug: 'seattle', name: 'Seattle', state: 'WA' },
  { slug: 'boston', name: 'Boston', state: 'MA' },
  { slug: 'san-diego', name: 'San Diego', state: 'CA' }
];

export const locationServices = [
  {
    prefix: 'testimonial-software',
    name: 'Testimonial Software',
    eyebrow: 'TESTIMONIAL SOFTWARE',
    keyword: 'testimonial service, testimonial software, and testimonial tool',
    summary: 'A complete testimonial tool for collecting, managing, and publishing customer stories from local customers.',
    benefits: [
      'One branded link to request video, text, or audio testimonials',
      'Review every response before it goes live',
      'Organize testimonials by service, team, or location',
      'Publish approved proof to your website in minutes'
    ],
    useCases: ['New customer onboarding', 'Local sales conversations', 'Website and landing pages', 'Case study creation']
  },
  {
    prefix: 'review-management-software',
    name: 'Review Management',
    eyebrow: 'REVIEW MANAGEMENT SOFTWARE',
    keyword: 'review management platform, google review software, and review management tools',
    summary: 'A review management platform that helps you monitor, request, and respond to Google reviews without losing track of feedback.',
    benefits: [
      'Request Google reviews with a simple shareable link',
      'Track review management performance in one dashboard',
      'Respond to feedback before it affects your reputation',
      'Turn strong reviews into publishable social proof'
    ],
    useCases: ['Multi-location review tracking', 'Local SEO and Google Business Profile', 'Front-desk and post-service requests', 'Reputation monitoring']
  },
  {
    prefix: 'review-widgets',
    name: 'Review Widgets',
    eyebrow: 'GOOGLE REVIEW WIDGET',
    keyword: 'google review widget and review widget',
    summary: 'A lightweight google review widget that displays your best reviews on any page without slowing your site down.',
    benefits: [
      'Embed a review widget with one line of code',
      'Auto-sync new Google reviews as they arrive',
      'Match widget styling to your brand',
      'Fast-loading, mobile-friendly review widget design'
    ],
    useCases: ['Homepage trust sections', 'Service and pricing pages', 'Local landing pages', 'Checkout and booking pages']
  },
  {
    prefix: 'video-testimonial-software',
    name: 'Video Testimonials',
    eyebrow: 'VIDEO TESTIMONIAL SOFTWARE',
    keyword: 'video testimonial software, video testimonial platform, and video testimonial service',
    summary: 'The easiest video testimonial software to collect video testimonials from customers using nothing but their phone.',
    benefits: [
      'Guided recording flow for authentic testimonial videos',
      'Collect video testimonials without an app download',
      'Auto-generate captions for every testimonial video',
      'Publish customer testimonial videos to your site or socials'
    ],
    useCases: ['Sales enablement clips', 'Homepage hero videos', 'Social media testimonial videos', 'Ad creative and landing pages']
  },
  {
    prefix: 'testimonial-collection-software',
    name: 'Testimonial Collection',
    eyebrow: 'TESTIMONIAL COLLECTION TOOL',
    keyword: 'testimonial form, customer testimonial form, and testimonial collection tool',
    summary: 'A dependable testimonial collection tool with a simple customer testimonial form that makes it easy to collect testimonials.',
    benefits: [
      'Send a branded testimonial form in seconds',
      'Collect testimonials from email, SMS, or QR code',
      'Customize your client testimonial form questions',
      'Store every response in one organized library'
    ],
    useCases: ['Post-project follow-up', 'Customer success workflows', 'Event and in-person collection', 'Recurring feedback requests']
  },
  {
    prefix: 'customer-feedback-software',
    name: 'Customer Feedback',
    eyebrow: 'CUSTOMER FEEDBACK SOFTWARE',
    keyword: 'customer feedback software, customer feedback management, and customer feedback form',
    summary: 'Customer feedback software with a flexible feedback form so your team can manage feedback from request to resolution.',
    benefits: [
      'Build a custom customer feedback form in minutes',
      'Centralize customer feedback management in one place',
      'Route client feedback software alerts to the right team',
      'Turn positive feedback into testimonials automatically'
    ],
    useCases: ['Customer support follow-up', 'Product and service feedback', 'Client feedback software for agencies', 'Internal quality tracking']
  },
  {
    prefix: 'social-proof-software',
    name: 'Social Proof',
    eyebrow: 'SOCIAL PROOF SOFTWARE',
    keyword: 'social proof software, social proof tools, and social proof tool',
    summary: 'Social proof software and tools that help you display trust signals exactly where local buyers are deciding.',
    benefits: [
      'Combine reviews, testimonials, and ratings in one social proof tool',
      'Show real-time activity and recent customer proof',
      'Segment social proof tools by location or service',
      'Measure how social proof software impacts conversions'
    ],
    useCases: ['Landing page conversion', 'Local service comparisons', 'Booking and quote pages', 'Multi-location marketing']
  },
  {
    prefix: 'testimonial-website-widgets',
    name: 'Website Widgets',
    eyebrow: 'WEBSITE TESTIMONIAL WIDGETS',
    keyword: 'website testimonials, testimonial rotator, and testimonial cards',
    summary: 'Beautiful website testimonials widgets, including a testimonial rotator and testimonial cards, for a polished testimonial section design.',
    benefits: [
      'Choose grid, carousel, or scrolling testimonials website widgets',
      'Use a testimonial rotator that updates automatically',
      'Apply a clean testimonial section design in a few clicks',
      'Responsive testimonial cards for any screen size'
    ],
    useCases: ['Website testimonial design refresh', 'Homepage social proof section', 'Service page testimonial cards', 'Scrolling testimonials for landing pages']
  }
];

export const locationSolutionPages = locationServices.flatMap((service) =>
  locationCities.map((city) => ({
    slug: `${service.prefix}-${city.slug}`,
    citySlug: city.slug,
    cityName: city.name,
    state: city.state,
    servicePrefix: service.prefix,
    serviceName: service.name,
    eyebrow: service.eyebrow,
    keyword: service.keyword,
    summary: service.summary,
    benefits: service.benefits,
    useCases: service.useCases
  }))
);

export function getLocationSolutionBySlug(slug) {
  return locationSolutionPages.find((page) => page.slug === slug);
}

export function getSiblingCitiesForService(servicePrefix, currentCitySlug) {
  return locationSolutionPages.filter(
    (page) => page.servicePrefix === servicePrefix && page.citySlug !== currentCitySlug
  );
}

export function getCitiesForService(servicePrefix) {
  return locationSolutionPages.filter((page) => page.servicePrefix === servicePrefix);
}
